import { CardContainer } from '@apps-common/components/common/CardContainer'
import { commonIcons } from '@apps-common/config/icons'
import { IonRouterLink } from '@ionic/react'

export const UnauthorizedCard: React.FC = () => {
  const WaringIcon = commonIcons.toastWarning

  return (
    <div className='flex items-center justify-center w-full h-full'>
      <CardContainer bgClasses='inline-block bg-surface border border-border md:min-w-[350px] md:py-8 flex items-center justify-center'>
        <div className='flex flex-col items-center justify-center gap-6 max-w-[200px] text-center text-text'>
          <div className='bg-warning/50 text-on-warning ring-1 ring-warning rounded-3xl p-4'>
            <WaringIcon className='text-[2.5em]' />
          </div>
          <p className='jost'>You are unauthorised to access this resource.</p>
          <IonRouterLink routerDirection='root' routerLink='/' className='text-text-muted text-[0.9em] px-2 py-1 action-warning'>
            <div className='!flex items-center justify-center gap-1'>
              <commonIcons.arrowRightShort className='rotate-180 text-[1.4rem]' /> Back to home
            </div>
          </IonRouterLink>
        </div>
      </CardContainer>
    </div>
  )
}
